import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "../../utils/api";
import ReviewsModal from "../Shared/ReviewsModal";
import { BASE_URL } from "../../utils/api";
const directories = [
    { id: "google", name: "Google Directory" },
    // { id: "kununu", name: "Kununu Directory" },
    // { id: "trustpilot", name: "Trustpilot Directory" },
    // { id: "golocal", name: "GoLocal Directory" },
    // { id: "jameda", name: "Jameda Directory" },
];


const RequestDirectoryModal = ({ isOpen, onClose, company }) => {
    const [statuses, setStatuses] = useState({});
    const [loading, setLoading] = useState(false);
    const [googleListings, setGoogleListings] = useState([]);
    const [showListingModal, setShowListingModal] = useState(false);
    const [connectedListingTitle, setConnectedListingTitle] = useState("");
    const [justDisconnected, setJustDisconnected] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [googleReviews, setGoogleReviews] = useState([]);
    const [loadingReviews, setLoadingReviews] = useState(false);
const [connectedListingId, setConnectedListingId] = useState("");
    const [overallRating, setOverallRating] = useState(0);
    const [totalRatings, setTotalRatings] = useState(0);
    const [companyName, setCompanyName] = useState("");

    const token = localStorage.getItem("token");
   const handleViewReviews = async (companyId) => {
    try {
        setLoadingReviews(true);
        setShowModal(true);

        const res = await API.get(`/google/reviews`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { companyId } // ✅ only companyId
        });

        console.log("Response of reviews", res.data);

        setGoogleReviews(res.data.reviews || []);
        setOverallRating(res.data.overallRating || 0);
        setTotalRatings(res.data.totalRatings || 0);
        setCompanyName(res.data.company || "");
    } catch (err) {
        console.error("Failed to fetch reviews:", err);
        alert("Could not load reviews. Please try again.");
    } finally {
        setLoadingReviews(false);
    }
};






    const handleSelectListing = async (listing) => {
        console.log("👀 Selected listing passed to function:", listing); // Add this
        try {
            await API.post(
                "/google/select-listing",
                {
                    companyId: company._id,
                    listing: {
                        id: listing._id,
                        title: listing.title
                    }
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
 setConnectedListingTitle(listing.title); // ✅ update title
        setConnectedListingId(listing.id);
            setShowListingModal(false);
            fetchDirectoryStatuses(); // Refresh the view
        } catch (error) {
            console.error("Failed to select listing:", error);
            alert("Failed to select listing");
        }
    };

    const fetchDirectoryStatuses = async () => {
        console.log("googleListings", googleListings);
        try {
            setLoading(true);
            const [requestsRes, companyRes] = await Promise.all([
                API.get(`/listing-requests?companyId=${company._id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                }),
                API.get(`/companies/${company._id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);

            console.log("requestsRes", requestsRes);
            console.log("companyRes", companyRes);

            const directoryStatuses = {};

            directories.forEach((dir) => {
                if (dir.id === "google") {
                    const googleAuth = companyRes.data?.data?.socialMedia?.googleAuth;

                    const match = requestsRes.data.data.find(
                        (req) =>
                            String(req.directory?._id || req.directory) === dir.id &&
                            req.company && String(req.company._id) === String(company._id)
                    );



                    if (match?.status === "approved") {
                        directoryStatuses[dir.id] = "listing_created";
                    } else if (match?.status === "pending") {
                        directoryStatuses[dir.id] = "listing_requested";
                    } else if (match?.status === "rejected") {
                        directoryStatuses[dir.id] = "listing_not_found";
                    } else {
                        // Fall back to checking googleAuth
                        if (googleAuth?.accessToken && !googleAuth.isConnected) {
                            directoryStatuses[dir.id] = "listing_not_found";
                        } else {
                            directoryStatuses[dir.id] = googleAuth?.isConnected ? "connected" : "not_connected";
                        }
                    }
                }

                else {
                    const match = requestsRes.data.data.find(
                        (req) => String(req.directory?._id || req.directory) === String(dir.id)
                    );



                    if (!match) {
                        directoryStatuses[dir.id] = "not_connected";
                    } else if (match.status === "approved") {
                        directoryStatuses[dir.id] = "listing_created";
                    } else if (match.status === "pending") {
                        directoryStatuses[dir.id] = "listing_requested";
                    } else if (match.status === "rejected") {
                        directoryStatuses[dir.id] = "listing_not_found";
                    }
                }


            });
            const googleAuth = companyRes.data?.data?.socialMedia?.googleAuth;
            if (!justDisconnected &&
                googleAuth?.isConnected && googleAuth?.selectedListing?.title) {
                setConnectedListingTitle(googleAuth.selectedListing.title);
                 setConnectedListingId(googleAuth.selectedListing.id);
            } else {
                setConnectedListingTitle("");
                setConnectedListingId("");
            }


            if (googleAuth?.mockListings?.length > 0 && !googleAuth.selectedListing) {
                setGoogleListings(googleAuth.mockListings);
                setShowListingModal(true); // ✅ Show modal to select listing
            }

            setStatuses(directoryStatuses);
        } catch (error) {
            console.error("Failed to fetch statuses:", error);
        } finally {
            setLoading(false);
        }
        setJustDisconnected(false);

    };


    useEffect(() => {
        if (!isOpen) return;

        const connectedCompanyId = localStorage.getItem("google_connected_company");
        if (connectedCompanyId === company._id) {
            fetchDirectoryStatuses();
            localStorage.removeItem("google_connected_company");
        } else {
            fetchDirectoryStatuses();
        }
    }, [isOpen]);




    const handleRequestListing = async (directoryId) => {
        try {
            await API.post(
                `/listing-requests`,
                {
                    directory: directoryId,
                    companyId: company._id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // ✅ Refresh the status from backend after request is sent
            await fetchDirectoryStatuses();
        } catch (error) {
            console.error("Request listing failed:", error);
        }
    };

    const handleConnectGoogle = async (companyId) => {
        try {
            // Store companyId temporarily for check after callback
            localStorage.setItem("google_connected_company", companyId);
            const token = localStorage.getItem("token");
            const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
            const role = payload.role;

            // Step 1: Redirect to Google OAuth
            window.location.href = `${BASE_URL}/api/v1/google/auth/google?companyId=${companyId}&role=${role}`;
        } catch (error) {
            alert("Failed to start Google connection.");
            console.error("Connect Google failed:", error);
        }
    };




    const handleConnect = async (directoryId) => {
        // Simulate "connect" as "approve" only for demo purposes
        try {
            await API.put(
                `/listing-requests/fake-connect`,
                {
                    directory: directoryId,
                    companyId: company._id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setStatuses((prev) => ({ ...prev, [directoryId]: "connected" }));
        } catch (error) {
            console.error("Connection failed:", error);
            setStatuses((prev) => ({ ...prev, [directoryId]: "listing_not_found" }));
        }
    };
    const handleDisconnect = async (directoryId) => {
        if (directoryId === "google") {
            try {
                await API.post(
                    "/google/disconnect/google",
                    { companyId: company._id },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setStatuses((prev) => ({
                    ...prev,
                    [directoryId]: "not_connected",
                }));
                setConnectedListingTitle("");
                setJustDisconnected(true);
                setConnectedListingTitle(""); // optional – just for UI speed

                // ✅ Refresh backend state after disconnect
                await fetchDirectoryStatuses();
            } catch (error) {
                console.error("Failed to disconnect:", error);
            }
        }
    };

    const renderAction = (dirId, status) => {
        console.log("status", status);
        switch (status) {
            case "connected":
                return (
                    <button
                        onClick={() => handleDisconnect(dirId)}
                        className="text-red-600 font-semibold hover:underline"
                    >
                        Disconnect
                    </button>
                );

            case "not_connected":
                return (
                    <button
                        onClick={() =>
                            dirId === "google"
                                ? handleConnectGoogle(company._id)
                                : handleConnect(dirId)
                        }
                        className="bg-gray-800 text-white px-4 py-1 rounded-md text-sm "
                    >
                        Connect
                    </button>

                );
            case "listing_not_found":
                return (
                    <button
                        onClick={() => handleRequestListing(dirId)}
                        className="bg-gray-800 text-white px-4 py-1 rounded-md text-sm"
                    >
                        Request Listing
                    </button>
                );
            case "listing_requested":
                return <span className="text-orange-500 font-medium">Waiting for Admin</span>;
            case "listing_created":
                return (
                    <button
                        onClick={() =>
                            dirId === "google"
                                ? handleConnectGoogle(company._id)
                                : handleConnect(dirId)
                        }
                        className="bg-gray-800 text-white px-4 py-1 rounded-md text-sm"
                    >
                        Connect
                    </button>
                );

            default:
                return <span className="text-gray-500">Loading...</span>;
        }
    };

    const renderStatus = (status) => {
        switch (status) {
            case "connected":
                return "Connected";
            case "not_connected":
                return "Not Connected";
            case "listing_not_found":
                return "Listing Not Found";
            case "listing_requested":
                return "Listing Requested";
            case "listing_created":
                return "Listing Created";
            default:
                return "Loading...";
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-4xl">
                <div className="flex items-center justify-between mb-8"><h2 className="text-xl font-semibold ">
                    Manage Directory Listings for{" "}
                    <span className="text-green-600">{company.name}</span>
                </h2>
                    <div className="text-right  ">
                        <button
                            onClick={onClose}
                            className="text-gray-600 bg-gray-900 rounded-md text-white  px-4 py-2"
                        >
                            Close
                        </button>
                    </div></div>


                {loading ? (
                    <p className="text-center text-gray-600">Loading statuses...</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white border rounded-lg">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 text-left">#</th>
                                    <th className="px-4 py-2 text-left">Directory</th>
                                    <th className="px-4 py-2 text-left">Status</th>
                                    <th className="px-4 py-2 text-left">Action</th>
                                    {directories.some((dir) => statuses[dir.id] === "connected") && (
                                        <>
                                            <th className="px-4 py-2 text-left">Connected Company</th>
                                            <th className="px-4 py-2 text-left">Reviews</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {directories.map((dir, index) => (
                                    <tr key={dir.id} className="border-t">
                                        <td className="px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">{dir.name}</td>
                                        <td className="px-4 py-2">{renderStatus(statuses[dir.id])}</td>
                                        <td className="px-4 py-2">{renderAction(dir.id, statuses[dir.id])}</td>
                                        {statuses[dir.id] === "connected" && (
                                            <>
                                                <td className="px-4 py-2">
                                                    {dir.id === "google" && connectedListingTitle && (
                                                        <div className=" font-medium">
                                                            <span className="text-green-600">{connectedListingTitle}</span>
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="px-4 py-2">
                                                    <button
                                                        onClick={() => handleViewReviews(company._id)}
                                                        className="text-black text-left hover:underline"
                                                        disabled={loadingReviews}
                                                    >
                                                        {loadingReviews ? "Loading..." : "View Reviews"}
                                                    </button>
                                                </td>
                                            </>
                                        )}

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <ReviewsModal

                            isOpen={showModal}
                            onClose={() => setShowModal(false)}
                            reviews={googleReviews}
                            overallRating={overallRating}
                            totalRatings={totalRatings}
                            companyName={companyName}
                            companyId={company._id}
                            directoryId="google"
                        />

                        {showListingModal && (
                            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                                <div className="bg-white rounded-lg p-6 max-w-lg w-full">
                                    <h2 className="text-lg font-semibold mb-4">Select a Google listing you want to connect </h2>
                                    <ul className="space-y-2">
                                        {googleListings.map((listing) => (
                                            <li key={listing.id} className="border p-3 rounded flex justify-between items-center">
                                                <span>{listing.title}</span>
                                                <button
                                                    onClick={() => handleSelectListing(listing)}
                                                    className="bg-gray-800 text-white px-3 py-1 rounded  text-sm"
                                                >
                                                    Select
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="text-right mt-4">
                                        {/* <button
                                            onClick={() => setShowListingModal(false)}
                                            className="text-gray-600 hover:underline text-sm"
                                        >
                                            Cancel
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}


            </div>
        </div>

    );

};

export default RequestDirectoryModal;
